import { Box, Container, Grid, Typography, Button } from '@material-ui/core'
import React, { useEffect, useState, useRef, useContext } from 'react'

import { Helmet } from 'react-helmet'
import Loader from '../components/utils/Loader'
import { useNavigate } from 'react-router-dom'
import { getPublicAPI } from '../api'
import ProductCard from '../components/fitting/ProductCard'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import { ShoppingCartContext } from '../contexts/ShoppingCart'
import socket from '../components/Socket'
import SearchResult from '../components/SearchResult'


const HomePage = () => {
   let mounted = useRef(true)
   const navigate = useNavigate()
   const { shopping, setShopping, searchC } = useContext(ShoppingCartContext)
   const { innerWidth: windowWidth } = window
   const [hoseData, setHoseData] = useState([])
   const [data, setData] = useState([])
   const [recent, setRecentData] = useState([])
   const [loading, setLoading] = useState(true)

   useEffect(() => {
      if (localStorage.auth_token) navigate('/app/dashboard')
      return () => (mounted.current = false)
   }, [navigate])

   useEffect(() => {
      const getFittings = async () => {
         try {
            let fittingsData = await getPublicAPI('/get-fittings-home')
            if (fittingsData?.success) {
               mounted.current && setData(fittingsData?.data)
            }
         } catch (err) {
            console.log(err.message)
         }

         try {
            let hosesData = await getPublicAPI('/get-hoses-home')
            if (hosesData?.success) {
               mounted.current && setHoseData(hosesData?.data)
            }
         } catch (err) {
            console.log(err.message)
         }

         let data = { recent: localStorage.recent ? JSON.parse(localStorage.recent) : null }
         try {
            let recentData = await getPublicAPI('/get-recent', data)
            if (recentData?.success) {
               mounted.current && setRecentData(recentData?.data)
            }
         } catch (err) {
            console.log(err.message)
         } finally {
            setLoading(false)
            setShopping(!shopping)
            // socket.emit('hello', "hello world")
            
         }
      }

      getFittings()

      return () => (mounted.current = false)
   }, [navigate, setShopping, shopping])
   
   socket.on('hello', msg => {console.log(msg) })
   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : 'Home | The HosePod'}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth={false}>
               {loading ? (
                  <Loader />
               )
                  : searchC ?
                     (
                        <SearchResult />
                     )
                  : (
                  <>
                     <Box
                        sx={{
                           display: 'flex',
                           flexDirection: windowWidth < 450 ? 'column' : 'row',
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           pt: 3
                        }}
                     >
                        <Typography
                           variant='h3'
                           sx={{ fontWeight: '500', letterSpacing: 2, color: '#474540' }}
                        >
                           FITTINGS
                        </Typography>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           flexDirection: windowWidth < 450 ? 'column' : 'row',
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           pt: 3
                        }}
                     >
                        <Grid container spacing={3}>
                           {data.map(product => (
                              <Grid item key={product._id} xl={2} lg={3} sm={4} xs={12}>
                                 <ProductCard home={true} product={product} />
                              </Grid>
                           ))}
                           <Grid item sm={12} sx={{ padding: 0, margin: 0 }}>
                              <Button
                                 onClick={() => navigate('/fittings')}
                                 color='primary'
                                 sx={{ float: 'right', display: 'flex', padding: 0, margin: 0 }}
                              >
                                 View All
                                 <ArrowForwardIcon />
                              </Button>
                           </Grid>
                        </Grid>
                     </Box>

                     <Box
                        sx={{
                           display: 'flex',
                           flexDirection: windowWidth < 450 ? 'column' : 'row',
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           pt: 2
                        }}
                     >
                        <Typography
                           variant='h3'
                           sx={{ fontWeight: '500', letterSpacing: 2, color: '#474540' }}
                        >
                           HOSES
                        </Typography>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           flexDirection: windowWidth < 450 ? 'column' : 'row',
                           justifyContent: 'space-between',
                           alignItems: 'center',
                           pt: 3
                        }}
                     >
                        <Grid container spacing={3}>
                           {hoseData.map(product => (
                              <Grid item key={product._id} xl={2} lg={3} sm={4} xs={12}>
                                 <ProductCard home={true} product={product} />
                              </Grid>
                           ))}
                           <Grid item sm={12} sx={{ padding: 0, margin: 0 }}>
                              <Button
                                 onClick={() => navigate('/hoses')}
                                 color='primary'
                                 sx={{ float: 'right', display: 'flex', padding: 0, margin: 0 }}
                              >
                                 View All
                                 <ArrowForwardIcon />
                              </Button>
                           </Grid>
                        </Grid>
                     </Box>
                     {recent && recent.length > 0 && (
                        <>
                           <Box
                              sx={{
                                 display: 'flex',
                                 flexDirection: windowWidth < 450 ? 'column' : 'row',
                                 justifyContent: 'space-between',
                                 alignItems: 'center',
                                 pt: 2
                              }}
                           >
                              <Typography
                                 variant='h3'
                                 sx={{ fontWeight: '500', letterSpacing: 2, color: '#474540' }}
                              >
                                 RECENTLY VIEWED
                              </Typography>
                           </Box>

                           <Box
                              sx={{
                                 display: 'flex',
                                 flexDirection: windowWidth < 450 ? 'column' : 'row',
                                 justifyContent: 'space-between',
                                 alignItems: 'center',
                                 pt: 3
                              }}
                           >
                              <Grid container spacing={3}>
                                 {recent.map(product => (
                                    <Grid item key={product._id} xl={2} lg={3} sm={4} xs={12}>
                                       <ProductCard home={true} product={product} />
                                    </Grid>
                                 ))}
                              </Grid>
                           </Box>
                        </>
                     )}
                  </>
               )}
            </Container>
         </Box>
      </>
   )
}

export default HomePage
